import Vue from 'vue/dist/vue.esm';
import Vuex from 'vuex/dist/vuex.esm';

Vue.use(Vuex);

function createStore(fragranceData) {
  return new Vuex.Store({
    state: {
      currentStateAbbr: ''
    },
    getters: {
      currentState(state) {
        return fragranceData[state.currentStateAbbr];
      }
    },
    mutations: {
      updateCurrentState(state, newStateAbbr) {
        state.currentStateAbbr = newStateAbbr;
      }
    }
  });
}

export default createStore;
